import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";

export function DocGateCard({ companyId, isAdmin }) {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { if (companyId) api.get("/onboarding/doc-gate", { params: isAdmin ? { company_id: companyId } : {} }).then((r) => setD(r.data)).catch(() => {}); }, [companyId, isAdmin]);
  if (!d || d.count === 0) return null;
  return (
    <Card className="p-4 sm:p-5 border-rose-200 bg-rose-50/40 dark:bg-rose-500/5" data-testid="doc-gate-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-semibold font-display flex items-center gap-2 text-rose-700"><AlertTriangle className="w-4 h-4" /> New-hire documents missing <span data-testid="doc-gate-count" className="text-xs font-mono-num px-1.5 py-0.5 rounded bg-rose-600 text-white">{d.count}</span></h3>
          <p className="text-xs text-muted-foreground mt-0.5">Starting within 7 days without an ID or a signed / verified I-9.</p>
        </div>
        <Button size="sm" variant="outline" data-testid="doc-gate-open" onClick={() => navigate("/hiring?tab=hires")}>Review new hires <ArrowRight className="w-3.5 h-3.5 ml-1" /></Button>
      </div>
      <ul className="mt-3 space-y-1 text-sm">
        {d.items.slice(0, 5).map((i) => <li key={i.id} data-testid={`doc-gate-item-${i.id}`} className="flex justify-between gap-2 border-b border-dashed border-border/60 py-1"><span className="truncate"><span className="font-medium">{i.name}</span> · {i.job_title}</span><span className="text-xs text-rose-700 whitespace-nowrap">{i.missing.join(", ")} · starts {fmtDate(i.start_date)}</span></li>)}
      </ul>
    </Card>
  );
}
